var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import useStyles from './styles';
import { Box, Button, Dialog as MUIDialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Icon, Typography, } from '@material-ui/core';
var iconVariants = {
    error: 'error_outline',
    warning: 'report_problem_outlined',
    info: 'info_outlined',
    confirm: 'info_outlined',
    notification: 'notification_important',
    search: 'error_outline',
};
var Dialog = function (_a) {
    var title = _a.title, message = _a.message, _b = _a.variant, variant = _b === void 0 ? 'error' : _b, open = _a.open, _c = _a.closeLabel, closeLabel = _c === void 0 ? 'OK' : _c, cancelLabel = _a.cancelLabel, handleClose = _a.handleClose, handleCancel = _a.handleCancel;
    var classes = useStyles({ variant: variant });
    var dialogIcon = useMemo(function () { return _jsx(Icon, __assign({ className: classes.icon }, { children: iconVariants[variant] }), void 0); }, [classes.icon, variant]);
    var handleClick = function (e) {
        e.stopPropagation();
    };
    return (_jsxs(MUIDialog, __assign({ open: open, onClose: handleCancel, onClick: handleClick }, { children: [title && (_jsx(DialogTitle, __assign({ role: "title", "data-testid": "dialog-title" }, { children: _jsxs(Box, __assign({ display: "flex", alignItems: "center", component: "span" }, { children: [dialogIcon, _jsx(Typography, __assign({ variant: "h4", component: "span" }, { children: title }), void 0)] }), void 0) }), void 0)),
            _jsx(DialogContent, __assign({ className: classes.content }, { children: _jsx(DialogContentText, __assign({ role: "message" }, { children: _jsxs(Box, __assign({ display: "flex", alignItems: "center", component: "span" }, { children: [!title && dialogIcon, _jsx(Typography, __assign({ component: "span" }, { children: message }), void 0)] }), void 0) }), void 0) }), void 0),
            _jsx(DialogActions, __assign({ "data-testid": "dialog-actions" }, { children: _jsxs(Box, __assign({ display: "flex", justifyContent: "flex-end" }, { children: [cancelLabel && (_jsx(Button, __assign({ className: classes.cancelBtn, onClick: handleCancel, role: "No", variant: "text" }, { children: cancelLabel }), void 0)),
                        _jsx(Button, __assign({ onClick: handleClose, role: "Yes", variant: "text" }, { children: closeLabel }), void 0)] }), void 0) }), void 0)] }), void 0));
};
export default Dialog;
